/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * TooltipOcpn component
 *
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.39.0
 */


import { icons } from '@/main/assets';
import { ImgStyled } from '@components/common/Block/Img';
import ArrowTooltip from '@components/common/Tooltip/Tooltip';

interface IRateplanTooltipIconProps {
    tooltip?: string;
}

export const RateplanTooltipIcon = (props: IRateplanTooltipIconProps) => {
    const { tooltip } = props;
    return tooltip
        ? <ArrowTooltip message={tooltip} placement="top">
            <div className="field-roaming__tooltip">
                <ImgStyled className="small" src={icons.infoBlueIcon} />
            </div>
        </ArrowTooltip>
        : null;
};
